import { useEffect, useState } from "react";
import DeactivateDevicesModal from './DeactivateDevicesModal.js';

export default function DeactivateDevicesModalViewModel(
    {
        isOpen,
        isLoading,
        handleClose,
        submitHandler,
        devices,
        setDevices,
        subscriptions,
        newLicenseCount }) {

    const [licenseDiffernce, setLicenseDiffernce] = useState(0);
    const [filteredDevices, setFilteredDevices] = useState([]);
    const [searchTerm, setSearchTerm] = useState(null);

    useEffect(() => {
        const numberOfActiveDevices = devices?.filter(x => x.autoRenew)?.length
        setLicenseDiffernce(newLicenseCount - numberOfActiveDevices);
    }, [newLicenseCount, devices]);

    useEffect(() => {
        if (searchTerm != null && searchTerm.trim() !== '') {
            setFilteredDevices(devices?.filter(x =>
                x.deviceName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                x.locationName.toLowerCase().includes(searchTerm.toLowerCase())
            ));
        }
        else {
            setFilteredDevices(devices);
        }
    }, [devices, searchTerm]);

    const statusChange = (accountId) => {
        const newDeviceList = devices.map((item) => {
            if (item.accountId === accountId) {
                const updatedDevice = {
                    ...item,
                    autoRenew: !item.autoRenew
                };

                return updatedDevice;
            }

            return item;
        })

        setDevices(newDeviceList);
    }

    return (
        <DeactivateDevicesModal
            isOpen={isOpen}
            isLoading={isLoading}
            licenseDiffernce={licenseDiffernce}
            statusChange={statusChange}
            subscriptions={subscriptions}
            filteredDevices={filteredDevices}
            submitHandler={submitHandler}
            handleClose={handleClose}
            setSearchTerm={setSearchTerm}
        />
    )

};